import {
  Box,
  Dialog,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { StyledButton } from "../../../common/components/Button";
import { DialogHeader } from "../styles";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { grey } from "@mui/material/colors";

const rows = [
  { key: "chiefRequest", title: "Chief Patient Request" },
  { key: "treatmentType", title: "Treatment Type" },
  { key: "canineAndMolar", title: "Caninine And Molar Class Correction" },
  { key: "iprPermitted", title: "IPR Permitted" },
  { key: "attachmentsPermitted", title: "Attachments Permitted" },
  { key: "crowdingResolution", title: "Crowding Resolution" },
  { key: "overjet", title: "Overjet" },
  { key: "overbite", title: "Overbite" },
  { key: "archForm", title: "Arch form" },
  { key: "curveOfSpee", title: "Curve Of Spee" },
  { key: "futurePlacement", title: "Future Placement of Veneers/FPD/Dentures" },
  { key: "specificFuturePlacement", title: "Specific Future Placement" },
  { key: "upperMidline", title: "Upper Midline" },
  { key: "lowerMidline", title: "Lower Midline" },
  { key: "closeUpperSpacing", title: "Close Upper Spacing" },
  { key: "specificUpperSpacing", title: "Specific Upper Spacing" },
  { key: "closeLowerSpacing", title: "Close Lower Spacing" },
  { key: "specificLowerSpacing", title: "Specific Lower Spacing" },
  { key: "teethToBeExtracted", title: "Teeth to be Extracted" },
  { key: "additionalInstructions", title: "Additional Instructions" },
];

const ViewTreatmentPlanDialog = ({ caseDetails, open, onClose }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const scanProgress = caseDetails.caseProgressions.find(
      (p) => p.type === "Scanning"
    );

    if (!scanProgress || !scanProgress.treatmentPlan) {
      return;
    }

    console.log(scanProgress);

    const rx = JSON.parse(scanProgress.treatmentPlan);

    const values = rows.map((row) => {
      let value;

      if (typeof rx[row.key] === "boolean") {
        value = rx[row.key] ? "Yes" : "No";
      } else if (Array.isArray(rx[row.key])) {
        value = rx[row.key].join(", ");
      } else {
        value = rx[row.key];
      }

      return {
        title: row.title,
        value,
      };
    });
    console.log(rx);
    console.log(values);

    setData(values);
  }, [caseDetails]);

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <Box sx={{ paddingX: 3, paddingY: 2 }}>
        <DialogHeader>
          Treatment Plan
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </DialogHeader>
        <Box sx={{ marginTop: 2 }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead sx={{ bgcolor: "#f0f0f0" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: grey[700] }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: grey[700] }}>
                    Value
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((data) => (
                  <TableRow key={data.title}>
                    <TableCell sx={{ fontWeight: 600 }}>{data.title}</TableCell>
                    <TableCell>{data.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{ display: "flex", marginY: 2 }}>
          <Box sx={{ marginLeft: "auto" }}>
            <StyledButton theme="green" onClick={onClose}>
              Close
            </StyledButton>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ViewTreatmentPlanDialog;
